<template>
  <div class="g-checkbox">
    <label class="g-checkbox-label">
      <span
        class="v-checkbox">
        <input
        class="v-checkbox-input"
        type="checkbox"
        v-model="currentValue"
        @change="$emit('change',$event)"
        :disabled="option.disabled"
        :value="option.value || option">
        <span class="v-checkbox-core"></span>
      </span>
      <span class="g-checkbox-text" v-text="option.label || option" v-if="option.label"></span>
    </label>
    <span class="g-checkbox-text" v-text="option.text || option" v-if="option.text"></span>
  </div>
</template>

<script>
/**
 * mt-checklist
 * @module components/checklist
 * @desc 复选框列表，依赖 cell 组件
 * @param {(string[]|object[])} options - 选项数组，可以传入 {label: 'label', value: 'value', disabled: true}
 * @param {string} value - 选中值
 * @example
 * <v-checkbox :v-model="value" :options="{label:"a",value:"b"}"></v-checkbox>
 */
export default {
  name: 'VCheckbox',

  props: {
    title: String,
    option: {
      type: Object,
      required: true
    },
    value: ''
  },

  data () {
    return {
      currentValue: this.value
    };
  },

  watch: {
    value (val) {
      this.currentValue = val;
    },
    currentValue (val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var.scss";
.g-checkbox {
  display: block;
  .g-checkbox-label {
    .v-checkbox {
      width: 20px;
      height: 20px;
      display: inline-block;
      position: relative;
      input {
        display: none;
        position: absolute;
        height: 100%;
        width: 100%;
        &:checked {
          + .v-checkbox-core {
            background-color: $color-red;
            border-color: $color-red;
            &::after {
              border-color: $color-white;
              transform: rotate(45deg) scale(1);
            }
          }
        }
        &[disabled] + .v-checkbox-core {
          background-color: $color-grey;
          border-color: #ccc;
        }
      }
      .v-checkbox-core {
        display: inline-block;
        background-color: $color-white;
        border-radius: 100%;
        border: 1px solid #ccc;
        position: relative;
        width: 20px;
        height: 20px;
        vertical-align: middle;
        &::after {
          border: 2px solid transparent;
          border-left: 0;
          border-top: 0;
          content: " ";
          position: absolute;
          top: 3px;
          left: 6px;
          height: 8px;
          width: 4px;
          transform: rotate(45deg) scale(0);
          transition: transform 0.2s;
        }
      }
    }
    
  }
  .g-checkbox-text{
      vertical-align: middle;
      font-size: 1.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/base/checkbox.vue